import { z } from "zod";
import { accessDenialExtensionV1Schema } from "./access-control.js";
export const problemDetailIssueSchema = z.object({
    path: z.array(z.union([z.string(), z.number()])).optional(),
    message: z.string(),
    code: z.string().optional(),
});
export const problemDetailsSchema = z.object({
    type: z.string(),
    title: z.string(),
    status: z.number().int(),
    detail: z.string().optional(),
    instance: z.string().optional(),
    code: z.string().regex(/^[a-z][a-z0-9_.:-]{0,159}$/u).optional(),
    refusedCapabilities: z.array(z.string().min(1).max(120)).max(16).optional(),
    policyRevisionOmitted: z.literal("too_large").optional(),
    diagnosticId: z.string().trim().min(1).max(100).optional(),
    issues: z.array(problemDetailIssueSchema).optional(),
}).extend(accessDenialExtensionV1Schema.partial().shape);
